import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { printSessionLog, clearSessionLog } from "./utils/session-log";
import "./themes/globalStyles.css";
import "./helpers/chartjs-zoom-fix";

printSessionLog();
(window as unknown as Record<string, unknown>).t2bSessionLog = printSessionLog;
(window as unknown as Record<string, unknown>).t2bClearSessionLog = clearSessionLog;

// Detecta se está em iframe ou domínio de preview
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovable.app") ||
  window.location.hostname.includes("lovableproject.com");

// Registra SW apenas em produção real
if ("serviceWorker" in navigator && !isInIframe && !isPreviewHost) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => console.log("SW registered:", reg.scope))
      .catch((err) => console.log("SW registration failed:", err));
  });
} else if ("serviceWorker" in navigator && (isInIframe || isPreviewHost)) {
  // Remove SWs residuais em ambiente de preview
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
);
